// Authorization header for user-chat REST calls in the legacy ai-chat module.
// Reads the access token from the auth store (mirrors src/lib/api/axios.ts) so these
// raw fetch() calls authenticate with the JWT instead of the (removed, spoofable)
// X-User-Id header. The backend derives the current user from the verified token.
import { useAuthStore } from '@/app/store/auth'

/**
 * Build request headers with the Bearer access token.
 * @param {Record<string,string>} extra - additional headers (e.g. Content-Type)
 */
export function authHeaders(extra = {}) {
  const token = useAuthStore.getState().accessToken
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  }
}

/** The current access token, for socket.io handshake auth ({ auth: { token } }). */
export function getAccessToken() {
  return useAuthStore.getState().accessToken
}
